import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getJobHistory } from "../Actions/API/Job/JobActions"
import { JobHistoryModel, JobHistoryQueryParams } from "../Models/API/JobModel"
import { FetchState } from "../Models/Client/FetchState"
import { useAppState } from "./useReduxState"
import { getPageToFetch } from "../Models/Client/RemoteData"

export function useJobHistory(
    jobID: string | undefined
): FetchState<JobHistoryModel> {
    const dispatch = useDispatch()
    const historyFetch = useAppState(state => {
        if (jobID === undefined) {
            return
        }

        return state.api.jobs.history[jobID]
    })

    useEffect(() => {
        if (jobID === undefined || historyFetch !== undefined) {
            return
        }

        const page = getPageToFetch(historyFetch, JobHistoryQueryParams)

        if (page >= 0) {
            dispatch(getJobHistory(jobID, page))
        }
    }, [dispatch, historyFetch, jobID])

    return historyFetch
}
